// @flow

import React, { useCallback, useRef } from "react";

import { Edit as StyledEdit } from "./styles";
import { SmallText as Input } from "src/styles/input";
import OutsideClickHandler from "src/components/OutsideClickHandler";

type Props = {
  value: string,
  handleChange: Function,
  handleClose: Function,
};

const Edit = ({ value, handleChange, handleClose }: Props) => {
  const outerRef = useRef(null);

  const handleClickOutside = useCallback(
    (event: any) => {
      if (
        outerRef &&
        outerRef.current &&
        !outerRef.current.contains(event.target)
      ) {
        handleClose();
      }
    },
    [outerRef, handleClose],
  );

  const handleKeyDown = useCallback(
    (event: any) => {
      if (event.key === "Enter") {
        handleClose();
      }
    },
    [handleClose],
  );

  return (
    <OutsideClickHandler onClickOutside={handleClickOutside}>
      <StyledEdit ref={outerRef}>
        <Input
          value={value}
          autoFocus
          onKeyDown={handleKeyDown}
          onChange={handleChange}
        />
      </StyledEdit>
    </OutsideClickHandler>
  );
};

export default Edit;
